/**
 * Všechny vestavěné texty aplikace, zaregistrované do instance i18next.
 *
 * Importuje ho vstup aplikace (``main.tsx``) jako PRVNÍ import a testy
 * (``tests/setup.ts``). Dřív to dělal přímo ``@/i18n`` — a protože ten
 * modul importuje přes 500 souborů, visely texty včetně ``admin.json`` na
 * statickém grafu i u ``/embed`` (KAN-223). ``/embed`` má vlastní
 * podmnožinu v ``embedResources.ts``.
 *
 * Proč jako první import: moduly se vyhodnocují v pořadí importů, a kdyby
 * některý modul četl text už při načtení (konstanta na úrovni modulu),
 * musí být texty v instanci dřív než on.
 */

import { registerBundles } from "@/i18n";

import csAccount from "./locales/cs/account.json";
import csAdmin from "./locales/cs/admin.json";
import csAuth from "./locales/cs/auth.json";
import csBuyer from "./locales/cs/buyer.json";
import csCart from "./locales/cs/cart.json";
import csCheckout from "./locales/cs/checkout.json";
import csCommon from "./locales/cs/common.json";
import csContact from "./locales/cs/contact.json";
import csHowItWorks from "./locales/cs/how_it_works.json";
import csLegal from "./locales/cs/legal.json";
import csMaterials from "./locales/cs/materials.json";
import csOrder from "./locales/cs/order.json";
import csPricing from "./locales/cs/pricing.json";
import csPublic from "./locales/cs/public.json";
import csQuote from "./locales/cs/quote.json";
import csSaas from "./locales/cs/saas.json";
import csTrack from "./locales/cs/track.json";
import enAccount from "./locales/en/account.json";
import enAdmin from "./locales/en/admin.json";
import enAuth from "./locales/en/auth.json";
import enBuyer from "./locales/en/buyer.json";
import enCart from "./locales/en/cart.json";
import enCheckout from "./locales/en/checkout.json";
import enCommon from "./locales/en/common.json";
import enContact from "./locales/en/contact.json";
import enHowItWorks from "./locales/en/how_it_works.json";
import enLegal from "./locales/en/legal.json";
import enMaterials from "./locales/en/materials.json";
import enOrder from "./locales/en/order.json";
import enPricing from "./locales/en/pricing.json";
import enPublic from "./locales/en/public.json";
import enQuote from "./locales/en/quote.json";
import enSaas from "./locales/en/saas.json";
import enTrack from "./locales/en/track.json";

registerBundles({
  cs: {
    common: csCommon,
    quote: csQuote,
    cart: csCart,
    checkout: csCheckout,
    order: csOrder,
    admin: csAdmin,
    legal: csLegal,
    account: csAccount,
    auth: csAuth,
    buyer: csBuyer,
    track: csTrack,
    contact: csContact,
    materials: csMaterials,
    pricing: csPricing,
    public: csPublic,
    how_it_works: csHowItWorks,
    saas: csSaas,
  },
  en: {
    common: enCommon,
    quote: enQuote,
    cart: enCart,
    checkout: enCheckout,
    order: enOrder,
    admin: enAdmin,
    legal: enLegal,
    account: enAccount,
    auth: enAuth,
    buyer: enBuyer,
    track: enTrack,
    contact: enContact,
    materials: enMaterials,
    pricing: enPricing,
    public: enPublic,
    how_it_works: enHowItWorks,
    saas: enSaas,
  },
});
